import type { RoutingMode } from '../components/model-routing-control/model-routing-control';

const STORAGE_KEY = 'grigo_chat_routing_mode';

export function isAutoRoutingFeatureEnabled(): boolean {
  const raw = (process.env.REACT_APP_AUTO_ROUTING ?? '').trim().toLowerCase();
  if (!raw || raw === 'true' || raw === '1' || raw === 'yes' || raw === 'on') {
    return raw !== 'false' && raw !== '0' && raw !== 'off';
  }
  return false;
}

export function loadRoutingMode(): RoutingMode {
  if (!isAutoRoutingFeatureEnabled()) {
    return 'manual';
  }
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw === 'auto' || raw === 'manual') {
      return raw;
    }
  } catch {
    /* ignore */
  }
  return 'auto';
}

export function saveRoutingMode(mode: RoutingMode): void {
  try {
    localStorage.setItem(STORAGE_KEY, mode);
  } catch {
    /* ignore */
  }
}
